import { render, staticRenderFns } from "./familyHubList.vue?vue&type=template&id=4e16fff8&scoped=true"
import script from "./familyHubList.vue?vue&type=script&lang=ts"
export * from "./familyHubList.vue?vue&type=script&lang=ts"
import style0 from "./familyHubList.vue?vue&type=style&index=0&id=4e16fff8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e16fff8",
  null
  
)

export default component.exports